export default function Checkbox(props) {
  return (
    <input type="checkbox" className="w-4 h-4" {...props} />
  );
}